const BASE_URL = "https://takestock-8d8f9914fc39.herokuapp.com";

// http://127.0.0.1:8000
// https://takestock-8d8f9914fc39.herokuapp.com
export { BASE_URL };